import { useLoggedOutSuppliersBrandsSearchRequestContext } from "@faire/retailer-visitor-shared/views/suppliers/__internal__/LazySuppliersPage/__internal__/SuppliersPage/__internal__/DataFetching/BrandsSearch/BrandsSearchContext/LoggedOutSuppliersBrandsSearchRequestContext";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import brandsSearch from "@faire/web-api--source/endpoints/www/api/v2/search/brands/get";
import { useQuery } from "@tanstack/react-query";
import isEmpty from "lodash/isEmpty";

export const useBrandsSearchQuery = () => {
  const { request, requestKey } =
    useLoggedOutSuppliersBrandsSearchRequestContext();

  const {
    data: response,
    dataUpdatedAt,
    isPending,
    isError,
    error,
  } = useQuery({
    // Disabled because requestKey *is* derived from request.
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: requestKey,
    queryFn: ({ signal }) => brandsSearch(request, { signal }),
    staleTime: 1000 * 60 * 5,
  });

  const data = !isEmpty(response)
    ? {
        brandSearchResults: response.brands.filter(isNotUndefined),
        filterSections: response.filter_sections,
        paginationData: response.pagination_data,
        pageCount: response.pagination_data?.page_count,
        totalPrimaryResultsCount:
          response.formatted_total_primary_results_count,
      }
    : undefined;

  return { data, dataUpdatedAt, isError, isPending, error };
};
